import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["trigger"]

  toggle(event) {
    event.preventDefault()

    const expanded = this.element.classList.toggle("--is-expanded")

    this.triggerTarget.setAttribute("aria-expanded", String(expanded))
  }
}
